/* unplugin-vue-components disabled */import { render } from "./PunishPage.vue?vue&type=template&id=441a5d34&scoped=true"
import script from "./PunishPage.vue?vue&type=script&lang=js"
export * from "./PunishPage.vue?vue&type=script&lang=js"

import "./PunishPage.vue?vue&type=style&index=0&id=441a5d34&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgy-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441a5d34"]])

export default __exports__